import React from 'react'
import { Link } from 'react-router-dom';

import './topBar.scss'

const TopBar = () => {
	return (
		<div className="top-bar">
			<Link to="/" className="sg-icon">
				<img
					alt="Supreme Golf Icon"
					src={require('../../assets/img/sg-logo.svg')}
				></img>
			</Link>
		</div>
	)
}

export default TopBar
